export default class PageContext {
    pageName!: string;
    pageCode!: string;
    subPageCode?: string;
    requireLogin = false;
    eventBus?: any;
  }
  